import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <p className="muted small">© {year} · Built with ❤️ using React</p>
    </footer>
  );
};

export default Footer;
